module.exports = __webpack_public_path__ + "img/1726039125612-screenshot-1726039083133.png.03f7435a.webp";